/**
 * คัดลอกข้อความเข้า clipboard
 *
 * ใช้ navigator.clipboard ก่อน (ต้องเป็น secure context) ถ้าไม่มีหรือถูกปฏิเสธ
 * (เช่น หน้า http หรือ WebView เก่า) fallback เป็น textarea + execCommand
 * โดยเช็คผลลัพธ์จริง — คัดลอกไม่สำเร็จจะ throw เสมอ ไม่มีทางสำเร็จปลอม
 */
export const copyText = async (text: string): Promise<void> => {
	if (navigator.clipboard?.writeText) {
		try {
			await navigator.clipboard.writeText(text);
			return;
		} catch {
			// ถูกปฏิเสธ (permission/iframe) — ลอง fallback ต่อด้านล่าง
		}
	}

	const ta = document.createElement('textarea');
	ta.value = text;
	ta.setAttribute('readonly', 'true');
	ta.style.position = 'fixed';
	ta.style.opacity = '0';
	document.body.appendChild(ta);
	try {
		ta.select();
		// iOS Safari ไม่ select เนื้อหา textarea ด้วย select() อย่างเดียว
		ta.setSelectionRange(0, ta.value.length);
		if (!document.execCommand('copy')) {
			throw new Error('เบราว์เซอร์ไม่อนุญาตให้คัดลอก');
		}
	} finally {
		document.body.removeChild(ta);
	}
};
